import React from "react";
import { fmtDate } from "../lib/api";
import { Card, Chip } from "./ui";

export default function ScoreListCard({ s, onClick }) {
  const line = (team) => {
    const sc = s.scores.find((x) => x.team === team);
    return sc ? `${sc.runs}/${sc.wickets} (${sc.overs})` : "Yet to bat";
  };
  return (
    <Card className="py-4 px-5 cursor-pointer" onClick={onClick} data-testid={`score-card-${s.id}`}>
      <div className="flex items-center gap-2 mb-2">
        {s.status === "completed"
          ? <Chip>Completed</Chip>
          : <Chip tone="danger">● Live</Chip>}
        <span className="text-xs text-ink-muted truncate">{s.title} • {fmtDate(s.created_at)}</span>
      </div>
      {s.teams.map((t, i) => (
        <div key={i} className="flex items-center justify-between py-0.5">
          <span className="font-semibold truncate">{t}</span>
          <span className="font-bold tabular-nums text-sm">{line(i)}</span>
        </div>
      ))}
      {s.result && <div className="text-sm text-brand font-semibold mt-2">{s.result}</div>}
    </Card>
  );
}
